import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { getFormattedNumber } from '../../../../../../../../common/utils'
import Status from '../status'

class FiberLengthLossInsLossTable extends React.Component {
  constructor(props) {
    super(props)
  }

  getFiberQualificationDiagram(classes, mode, singlefiber) {
    let imgSource = '/images/FiberLengthLossTest/Qualification/';
    if (singlefiber) {
      imgSource += "FiberTest_single.png";
    }
    else if (mode === "MM") {
      imgSource += "FiberTest_MM.png";
    }
    else {
      imgSource += "FiberTest_SM.png";
    }
	  return (
      <TableCell>
        <img className={classes.fiberQualImage} alt="" src={imgSource} />
      </TableCell>)
  }

  getMeasurementDiagramWithTitle(classes, measurement, remote, bidirectional, singlefiber, cordref, maintoremote, remotetomain) {
    let imgSource = '/images/FiberLengthLossTest/'
    let jumper = cordref + 1
    let resultNum = (singlefiber && (jumper == 1)) ? measurement + 1 : measurement * 2 + remote + 1
    let title = (remote) ? maintoremote : remotetomain
  	title += ' : '
  	if (!singlefiber) {
		  title += "Fiber No."
    		if (resultNum <= 2) {
			    title += (remote) ? '2' : '1'
		    }
		    else {
			    title += (remote) ? '1' : '2'
		    }
	  }
	  else {
  		switch (cordref) {
			  case 0:
				  title += (resultNum == 1 || resultNum == 3) ? 'D -> C' : 'C -> D'
				  break
			  case 1:
			  case 2:
				  if (resultNum <= 2) {
					  title += (remote) ? 'A -> B' : 'B -> A'
				  }
				  else {
  					title += (remote) ? 'B -> A' : 'A -> B'
	  			}
		  		break
			  default:
				  break
		  }
	  }
	
	  if (singlefiber) {
		  imgSource += 'Single/' + jumper + 'jumper_testview_' 
      imgSource += (bidirectional) ? 'bidir' : 'unidir'
	  }
	  else {
		  imgSource += 'Dual/' + jumper + 'jumper_testview'
	  }
	  imgSource += '_res' + resultNum + '.png'

	  return (
      <TableCell>
        <h5>{title}</h5>
        <img className={classes.fiberImage} alt="" src={imgSource} />
      </TableCell>)
  }

  render() {
    const {
      fiberTestSetup,
      fiberInsLossData,
      translate,
      classes,
      showFiberQualificationResults
    } = this.props
    const bidirectional = fiberTestSetup.bidirectional
    const singlefiber = fiberTestSetup.singlefiber
    const cordref = fiberTestSetup.cordref
    const fiberData = fiberInsLossData.map((n, k) => {
      let wavelengthParts = n.wavelength.split(" ")
      let wavelengthString = (wavelengthParts.length > 0) ? wavelengthParts[0].replace("nm", "") : "-"
      let modeString = (wavelengthParts.length > 1) ? wavelengthParts[1] : "-"
      return {
        measurement: n.measurement,
        remote: n.remote,
        wavelength: wavelengthString,
        mode: modeString,
        refpower: n.refrxpower,
        rxpower: n.rxpowerlevel,
        loss: n.rxpowerloss,
        losslimit: (n.losslimit >= 0) ? getFormattedNumber(n.losslimit) : "-",
        lossmargin: (n.losslimit >= 0) ? getFormattedNumber(n.losslimit - n.rxpowerloss) : "-",
        teststatus: (n.losslimit >= 0) ? n.status == 4 ? 'Pass' : 'Fail' : 'Info'
      }
    }).sort((a, b) => (a.measurement - b.measurement || a.remote - b.remote))

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{showFiberQualificationResults ? translate('test_setup') : translate('fiber_measurement_direction')}</TableCell>
            <TableCell numeric>{translate('fiber_wavelength')}</TableCell>
            <TableCell numeric>{translate('test_mode')}</TableCell>
            <TableCell numeric>{translate('fiber_reference_power')}</TableCell>
            <TableCell numeric>{translate('fiber_rx_power')}</TableCell>
            <TableCell numeric>{translate('fiber_ins_loss')}</TableCell>
            <TableCell numeric>{translate('fiber_loss_limit')}<br/>({translate('dB')})</TableCell>
            <TableCell numeric>{translate('fiber_loss_margin')}</TableCell>
            <TableCell numeric>{translate('fiber_result')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            (fiberData && fiberData.length) ? (fiberData.map((fiber, k) => {
              let lossStyle = fiber.teststatus && fiber.teststatus === 'Fail' ? { color: "red" } : { };
              return (<TableRow key={k}>
                {!showFiberQualificationResults ? this.getMeasurementDiagramWithTitle(classes, fiber.measurement, fiber.remote, bidirectional, singlefiber, cordref, translate('fiber_main_to_remote'), translate('fiber_remote_to_main')) : this.getFiberQualificationDiagram(classes, fiber.mode, singlefiber)}
                <TableCell numeric>{fiber.wavelength}</TableCell>
                <TableCell numeric>{fiber.mode}</TableCell>
                <TableCell numeric>{getFormattedNumber(fiber.refpower)}</TableCell>
                <TableCell numeric>{getFormattedNumber(fiber.rxpower)}</TableCell>
                <TableCell numeric style={lossStyle}>{getFormattedNumber(fiber.loss)}</TableCell>
                <TableCell numeric>{fiber.losslimit}</TableCell>
                <TableCell numeric>{fiber.lossmargin}</TableCell>
                <TableCell numeric>{fiber.teststatus ? (<React.Fragment> <Status status={fiber.teststatus} /></React.Fragment>) : (translate('general_na'))}</TableCell>
              </TableRow>)
            })) : null}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(FiberLengthLossInsLossTable)

